import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAnnualReportDto, ISetupData } from '@modeso/types__aumico-lib-annualreport-be';
import { ICompanyNameIdLegalFormDTO } from '@modeso/types__aumico-lib-companies-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { IAccountingBasisDTO } from '@modeso/types__aumico-lib-settings-be';
import { GeneralInformationMode } from '../../enums/general-information-form-mode.enum';
import { IGeneralInformationV2Output } from '../../interfaces/general-information-form-output.interface';

@Component({
    selector: 'aumico-general-information-v2',
    templateUrl: './general-information-v2-wrapper.component.html',
    styleUrls: ['./general-information-v2.component.scss'],
})
export class GeneralInformationV2Component {
    @Input() mode: GeneralInformationMode = GeneralInformationMode.NEW;
    @Input() setupData: ISetupData | undefined;
    @Input() companies: ICompanyNameIdLegalFormDTO[] = [];
    @Input() accountingBases: INameId[] = [];
    @Input() arTemplates: INameId[] = [];
    @Input() currencies: INameId[] = [];
    @Input() reportTypes: INameId[] = [];
    @Input() reportLanguages: INameId[] = [];
    @Input() savedData: IGeneralInformationV2Output | undefined;
    @Input() currentLanguage = 'de-ch';
    @Input() defaultLanguage = 'de-ch';
    @Input() isCpmmActive = false;
    @Input() previousAnnualReportOptions: Partial<IAnnualReportDto>[] = [];

    @Output() companySelected = new EventEmitter<ICompanyNameIdLegalFormDTO>();
    @Output() accountingBasisSelected = new EventEmitter<IAccountingBasisDTO>();
    @Output() arTemplateSelected = new EventEmitter<string>();
    @Output() autofillReportForBalanceSelected = new EventEmitter<string>();
    @Output() autofillReportForIncomeSelected = new EventEmitter<string>();
    @Output() formDataChanged = new EventEmitter<IGeneralInformationV2Output>();
    @Output() formValidChanged = new EventEmitter<boolean>();

    // Expose the GeneralInformationMode enum to the template
    GeneralInformationMode = GeneralInformationMode;
}
